<template>
  <div id="listCitationDetail">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="canAccessPage === true">
        <div class="page-name">
          <div class="page-title">Citation Detail List</div>
          <!-- Button for Clear Cache -->
          <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
          <div class="btn-groups text-right">
            <a
              v-show="isUploadShow == false"
              href="javascript:void(0)"
              class="btn btn-secondary"
              v-on:click="openuploadDoc()"
            >
              <i class="fp-upload"></i> Upload Documents
            </a>
            <a
              href="javascript:void(0)"
              class="btn btn-secondary"
              v-on:click="exportCheck()"
              v-if="hideButton === false"
            >
              <i class="fp-export"></i> Export
            </a>
            <router-link
              v-show="isUploadShow == false"
              class="btn btn-secondary"
              v-bind:to="{ name: 'CitationList' }"
            >
              <i class="fp-back"> </i> Back</router-link
            >
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content vendor-invoice-list">
            <div class="btn-groups badge-buttons text-left mb-3">
              <div class="">
                <div
                  id="divTabMenu"
                  class="btn-group rental-btn-group-left"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    id="getOkCitationDetailList"
                    v-on:click="getOkCitationDetailList(this)"
                    :class="'btn btn-secondary ' + okSelected"
                  >
                    Ok
                  </button>
                  <button
                    type="button"
                    id="getErrorCitationDetailList"
                    v-on:click="getErrorCitationDetailList(this)"
                    :class="'btn btn-secondary ' + errorSelected"
                  >
                    Error
                  </button>
                  <button
                    type="button"
                    id="getAllCitationDetailList"
                    v-on:click="getAllCitationDetailList(this)"
                    :class="'btn btn-secondary ' + allSelected"
                  >
                    All
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="admin-page-content citation-detail-list"
            v-show="isUploadShow == false"
          >
            <data-table-filter-config
              :moduleName="'citationDetailList'"
              ref="filterComponent"
              @cancelSelection="cancelAll"
              :allowSameFilter="'allow'"
            ></data-table-filter-config>
            <p
              v-if="batchProcess"
              class="alert-success p-2"
              id="processFetchBatchMsg"
            >
              Export file is in process. batch no. is {{ batchNum }}.
              <router-link
                class="color-blue"
                v-bind:to="{ name: 'BatchList' }"
                target="_blank"
                @click.native="batchProcess = 0"
              >
                Click Here</router-link
              >
              to check file status!
            </p>
            <section class="data-table bg-white">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange"
                :moduleName="'citationDetailList'"
                :position="'top'"
              >
              </custom-pagination>
              <vue-good-table
                ref="listCitationDetailTable"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :totalRows="totalRecords"
                @on-select-all="onSelectAll"
                title="Citation"
                :columns="userColumns"
                :rows="rows"
                :paginate="true"
                :paginationOptions="{
                  enabled: false,
                  position: 'both',
                  perPage: perPage,
                  perPageDropdown: dropDownPerPage,
                  dropdownAllowAll: false,
                }"
                :select-options="{
                  enabled: false,
                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                  selectionInfoClass: 'custom-class',
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
                }"
                :search-options="{
                  enabled: false,
                }"
              >
                <template
                  slot="table-row"
                  slot-scope="props"
                  v-for="(row, key) in rows"
                >
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <router-link
                        title="Edit Citation"
                        v-bind:key="'action' + key"
                        class="fp-edit mr-3"
                        v-bind:to="{
                          name: 'CitationEdit',
                          params: { id: props.row.id },
                        }"
                      ></router-link>
                      <a
                        v-if="props.row.file_path != null"
                        href="javascript:void(0)"
                        title="Agreement Download"
                        v-on:click="downloadFile(props.row.file_path)"
                      >
                        <i class="fp-download"></i>
                      </a>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>

                <div slot="selected-row-actions"></div>
              </vue-good-table>
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange"
              >
              </custom-pagination>
            </section>
          </div>

          <div
            class="admin-page-content citation-detail-list list-view"
            v-if="isUploadShow"
          >
            <p
              v-if="batchProcess"
              class="alert-success p-2"
              id="processFetchBatchMsg"
            >
              Current batch {{ batchNum }} is processing please wait!
              <router-link
                class="color-blue"
                v-bind:to="{ name: 'BatchList' }"
                target="_blank"
                @click.native="batchProcess = 0"
              >
                Click Here</router-link
              >
              to check file status!
            </p>
            <section class="internal-container border-top-table-fl">
              <div
                class="custom-dropzone-container custom-photo-user-dropzone dropzone-margin"
              >
                <label class="control-label" for="documents"
                  >Documents (.jpg, .jpeg, .png and .pdf files are
                  allowed)</label
                >
                <div id="app2">
                  <vue-dropzone
                    id="selfInsuranceDocs"
                    :options="dropzoneOptions"
                    :destroyDropzone="false"
                    ref="insuredDropzone"
                    :headers="dropzoneOptions.headers"
                    @vdropzone-complete="afterComplete"
                    @vdropzone-success="storeDocument"
                    @vdropzone-duplicate-file="duplicateDocument"
                    @vdropzone-error="errorDocument"
                    @vdropzone-removed-file="removedSelectedFile"
                  >
                  </vue-dropzone>
                  <div class="field-error">{{ doc_error_msg }}</div>
                  <div v-if="dropZonePreviewFiles.length > 0">
                    <div class="policy-attachment attachment-list-box">
                      <label class="control-label" for="attachments"
                        >Attachments</label
                      >
                      <template v-for="(uFile, fKey) in dropZonePreviewFiles">
                        <div
                          v-bind:key="'fileDiv' + fKey"
                          class="attachment-list"
                        >
                          <i
                            v-if="uFile.extension == 'pdf'"
                            class="fp-pdf-icon"
                          ></i>
                          <i
                            v-if="
                              uFile.extension == 'doc' ||
                              uFile.extension == 'docs'
                            "
                            class="fp-text-document"
                          ></i>
                          <i
                            v-if="
                              uFile.extension == 'jpg' ||
                              uFile.extension == 'png' ||
                              uFile.extension == 'jpeg'
                            "
                            class="fp-image"
                          ></i>
                          <a
                            title="View File"
                            href="javascript:void(0)"
                            v-on:click="
                              openDocument(uFile.url, uFile.extension)
                            "
                            v-bind:key="'fileName' + fKey"
                          >
                            {{ uFile["display_name"] }}
                          </a>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <button
                            type="button"
                            v-bind:key="'cancelBtn' + fKey"
                            v-on:click="
                              removeServerFile(uFile['file_name'], fKey)
                            "
                          >
                            <i class="fp-close"></i>
                          </button>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div style="margin-top: 15px">
                    <div
                      class="purchase-order-create-main form-group table-responsive-sm"
                    >
                      <table
                        aria-describedby="table"
                        class="table table-sm table-bordered font-1"
                      >
                        <thead>
                          <tr class="table-primary">
                            <th scope="col" style="">Toll ID</th>
                            <th scope="col" style="">Unit</th>
                            <th scope="col" style="">Upload</th>
                          </tr>
                        </thead>
                        <tbody id="myTable" v-if="files && files.length > 0">
                          <tr v-for="(row, index) in files" :key="index">
                            <td>
                              {{ getIdFromRec(row, "toll") }}
                            </td>
                            <td>
                              {{ getIdFromRec(row, "unit") }}
                            </td>
                            <td>
                              {{ row }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody id="myTable" v-else>
                          No Record Found
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <form
                  autocomplete="off"
                  class="form-horizontal basic-form-container form-custom-select"
                  id="insuranceDocForm"
                >
                  <div class="btn-groups">
                    <button
                      type="submit"
                      id="uploadInsuranceDoc"
                      class="btn btn-primary"
                      v-on:click.prevent="openuploadDoc"
                    >
                      <i class="fp-save"> </i> Save
                    </button>
                    <a
                      href="javascript:void(0)"
                      class="btn btn-secondary"
                      v-on:click="openuploadDoc()"
                    >
                      <i class="fp-close"></i> Close
                    </a>
                    <!-- button type="submit" id="uploadInsuranceDoc" class="btn btn-secondary" v-on:click.prevent="openuploadDoc">
                                    <i class="fp-close"> </i> Close
                                </button-->
                  </div>
                </form>
              </div>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="canAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import EventBus from "./event-bus";
import Vue from "vue";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import { commonMixins } from "../mixins/commonMixins";
import { dataTableMixins } from "../mixins/dataTableMixins";
import VueSSE from "vue-sse";
Vue.use(VueSSE);
let msgServer;
export default {
  name: "citationDetailList",
  metaInfo: {
    title: "Citation Detail List | FleetPro Application",
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  mixins: [commonMixins, dataTableMixins],
  data: () => ({
    currentBatchId: "",
    doc_error_msg: "",
    uploadedFiles: "",
    dropzoneOptions: {
      url:
        process.env.ROOT_API +
        "/citation-docs?batch=" +
        window.location.pathname.split("/")[3],
      method: "POST",
      maxFilesize: 5.0, //MB
      maxFiles: 25,
      thumbnailWidth: 150, // px
      thumbnailHeight: 150,
      addRemoveLinks: true,
      duplicateCheck: true,
      acceptedFiles: ".jpg, .jpeg, .png, .pdf",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("tkn"),
        "Access-Control-Allow-Headers":
          "Origin, Content-Type, Authorization,X-Requested-With",
        "Cache-Control": "no-cache",
      },
      dictRemoveFileConfirmation: "Are you sure?You can't revert your action",
      destroyDropzone: false,
      dictDefaultMessage:
        "Drop files here to upload. Files upto maximum 5 MB size are allowed.",
    },
    dropZonePreviewFiles: [],
    files: [],
    isUploadShow: false,

    hideButton: false,
    firstLoad: 0,
    userColumns: [],
    columns: [
      {
        label: "Actions",
        field: "action",
        sortable: false,
      },
      {
        label: "Toll ID",
        field: "toll_id",
        fpFieldType: "text",
        html: false,
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "toll id", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Toll Date",
        field: "toll_datetime",
        fpFieldType: "date",
        html: false,
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Unit",
        field: "unit_no",
        fpFieldType: "text",
        html: false,
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Unit", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Status",
        field: "status",
        fpFieldType: "text",
        html: false,
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Status", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          // filterDropdownItems: ['Ok','Error'], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Errors",
        field: "error_msg",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "errors", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Location",
        field: "location",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "location", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Source",
        field: "source",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "location", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Toll Violation Agency",
        field: "toll_voilation_agency",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "toll_voilation_agency", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Customer",
        field: "customer",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Customer", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },

      {
        label: "Toll Amount",
        field: "toll_amount",
        fpFieldType: "integer",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Toll Amount", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Admin Fee",
        field: "admin_fee",
        fpFieldType: "integer",
        html: false,
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "admin fee", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
    ],
    rows: [],
    totalRecords: 0,
    loading: false,
    permissions: [],
    canAccessPage: "",
    action: "list",
    pageKey: "_citation_detail_list_",
    selectedFile: "",
    batchId: "",
    batchProcess: false,
    batchNum: "",
    okSelected: "",
    errorSelected: "",
    allSelected: "",
    flag: "",
  }),
  watch: {
    permissions: function (permission) {
      var self = this;
      permission.forEach(function (permissions) {
        if (permissions.name == "list_citation_detail") {
          self.canAccessPage = true;
        }
      });
      if (self.cantAccess == "") {
        self.canAccessPage = false;
      }
    },
  },
  created: function () {
    //this.serverParams.sort = {field:"start_date",type:"desc"};
  },
  mounted: function () {
    var self = this;
    // this.loadList();
    this.getPermissions();
    var path = window.location.pathname;
    // var segments = path.split("/")[3];
    // self.currentBatchId = segments[3];
  },
  methods: {
    getIdFromRec(rec, type) {
      var res = rec.split("_");
      if (type == "toll") {
        var res1 = res[2].split(".");
        return res1[0];
      } else {
        var res1 = res[1].split("/");
        return res1[1];
      }
    },
    downloadFile: function (file_path) {
      var save = document.createElement("a");
      save.href = file_path;
      save.download = file_path;
      save.target = "_blank";
      document.body.appendChild(save);
      save.click();
    },
    afterComplete(file, response) {
      var self = this;
    },
    duplicateDocument(file) {
      var self = this;
    },
    errorDocument(file, message, xhr) {
      let response = xhr.response;
      let parse = JSON.parse(response, (key, value) => {
        return value;
      });
      $(".dz-error-message span").text(parse.message);
    },
    storeDocument(file, response) {
      var self = this;
      self.doc_error_msg = "";
      var uploadResponse = response.content;

      //push doc path in files array

      if (self.files.length > 0) {
        var idx = self.files.findIndex((obj) => obj == uploadResponse);
        if (idx == -1) {
          self.files.push(uploadResponse);
        }
      } else {
        self.files.push(uploadResponse);
      }

      if (file.type != undefined) {
        var extension = file.type.split("/");
      }
    },
    removedSelectedFile(file, xhr, error) {
      var self = this;
      self.insurance_doc_error_msg = "";

      if (file.status != "error") {
        var fileName = JSON.parse(file.xhr.response).content;

        var fileArr = fileName.split("/");

        self.removeFileFromServer(fileArr[1], "citation_docs");

        for (var i = 0; i < self.files.length; i++) {
          if (self.files[i].includes(fileName)) {
            self.files.splice(i, 1);
            self.validateDocs.splice(i, 1);
          }
        }
      }
    },
    removeFileFromServer(file, flag) {
      var self = this;
      // var conAssetId = self.$route.params.id;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/remove-citation-doc",
        type: "POST",
        data: {
          filePath: file,
          batch: window.location.pathname.split("/")[3],
          flag: flag,
        },
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, "remove-insurance-doc");
        },
      });
    },
    openuploadDoc: function () {
      var self = this;

      if (self.isUploadShow) {
        self.isUploadShow = false;
        self.files = [];
        self.loadList();
      } else {
        self.isUploadShow = true;
      }
    },
    cancelAll: function (cancelAll) {
      this.$refs.listCitationDetailTable.unselectAllInternal();
    },
    exportCheck: function () {
      var count = 0;
      var actionFlag = "";
      var data = this.$refs["listCitationDetailTable"].selectedRows;
      count = data.length;
      if (this.serverParams.selectedAll == true) {
        actionFlag = "";
      } else if (count != 0 && count <= 100) {
        actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },
    checkBatchStatus: function () {
      var self = this;
      this.$sse(process.env.ROOT_API + "/check/batch-status/" + self.batchId, {
        format: "json",
      }) // or { format: 'plain' }
        .then((sse) => {
          // Store SSE object at a higher scope
          msgServer = sse;

          // Listen for messages without a specified event
          sse.subscribe("", (data) => {
            if (data.status == "1" || data.status == "2") {
              self.batchProcess = false;
              self.loadList();
              sse.close();
            }
          });
        })
        .catch((err) => {
          console.error("Failed to connect to server", err);
        });
    },
    loadList: function () {
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var data = this.$refs["listCitationDetailTable"].selectedRows;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        use.push(this.$refs["listCitationDetailTable"].selectedRows[i].id);
      }

      var self = this;
      self.loading = true;
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/citation-detail/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",

        data: {
          offset: offset,
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: self.serverParams.sort,
          flag: self.flag,
          selectedAll: self.serverParams.selectedAll,
          selectedRows: use,
          action: self.action,
          batch: self.$route.params.batch,
        },
        success: function (data) {
          self.loading = false;

          if (data.status == "success") {
            if (self.action == "export" || self.action == "export_queue") {
              if (data.code == "201") {
                alert(data.message);
              } else {
                if (self.action == "export") {
                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);
                } else {
                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";
            } else {
              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
              self.filteredFlag = false;
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, "citation-list");
        },
      });
    },
    openModal: function () {
      var self = this;
      self.selectedFile = "";
      self.duplicatePolicy = [];
      $("#policyFile").val("");
      self.import_error = "";
      $("#policy-modal").modal("show");
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      var self = this;
      self.selectedFile = file;
      self.import_error = "";
    },
    importCitation() {
      var self = this;
      self.import_error = "";
      if (self.selectedFile == "" || self.selectedFile == null) {
        self.import_error = "Please Select Excel File.";
        return;
      }
      var formData = new FormData();
      formData.append("myFile", self.selectedFile);

      self.loading = true;

      $.ajax({
        url: process.env.ROOT_API + "/citation/import",
        type: "POST",
        data: formData,
        headers: this.ajxHeaders,
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.batch_id) {
            self.batchProcess = true;
            self.batchId = data.batch_id;
            self.batchNum = data.batch;
            self.checkBatchStatus();
            $("#policy-modal").modal("hide");
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          $("#importButton").text("Import");
          $("#importButton").prop("disabled", false);
          $("#cancelButton").prop("disabled", false);
          self.generateStatusCodeMessage(jqXHR, true, "policy-import-error");
        },
      });
    },
    getOkCitationDetailList: function () {
      var self = this;
      $("#divTabMenu button").removeClass("active");
      $("#getOkCitationDetailList").addClass("active");
      self.$refs.filterComponent.clearSelectAll();
      localStorage.setItem("citation_detail_list_prev_tab", "ok");
      self.okSelected = "active";
      self.errorSelected = "";
      self.allSelected = "";
      self.flag = "ok";
      self.loadList();
    },
    getErrorCitationDetailList: function () {
      var self = this;
      $("#divTabMenu button").removeClass("active");
      $("#getErrorCitationDetailList").addClass("active");
      self.$refs.filterComponent.clearSelectAll();
      localStorage.setItem("citation_detail_list_prev_tab", "error");
      self.okSelected = "";
      self.errorSelected = "active";
      self.allSelected = "";
      self.flag = "error";
      self.loadList();
    },
    getAllCitationDetailList: function () {
      var self = this;
      $("#divTabMenu button").removeClass("active");
      $("#getAllCitationDetailList").addClass("active");
      self.$refs.filterComponent.clearSelectAll();
      localStorage.setItem("citation_detail_list_prev_tab", "all");
      self.okSelected = "";
      self.errorSelected = "";
      self.allSelected = "active";
      self.flag = "all";
      self.loadList();
    },
  },
};
</script>
<style scoped>
.vue-dropzone .dz-preview .dz-details {
  opacity: 1;
}
.vue-dropzone .dropzone .dz-preview:hover {
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/CitationDetailList.vue